module.exports = __webpack_public_path__ + "static/media/liushishishan3.418c794a.webp";